<template>
  <div>
    <Modal v-model="modal" fullscreen title='批量导入' id='pldr' on-visible-change='changemodal' :closable='false'>
      <ul>
        <li>
          <Table :columns="columns" :data="data" style='width:100%'></Table>
        </li>
      </ul>

      <div slot="footer">
        <Button type="default" @click='cancelModal'>取消</Button>
        <Button type="info" @click='excelmodal = true' icon="md-checkmark-circle-outline">本地编辑</Button>
        <Button type="info" @click='textmodal = true' icon="md-checkmark-circle-outline">在线编辑</Button>
        <Button type="primary" @click='saveData' icon="md-checkmark-circle-outline">导入</Button>
      </div>
    </Modal>
    <Modal v-model="textmodal" title="在线模式" width='700px' id='wbms'>
      <p>
      <pre>
    如需【在输入框】手动修改内容：直接替换原数据即可，
    新内容使用换行符【回车键】增加行，数据之间用一个空格间隔开
    <span style='color:red'>请按照输入框内格式添加内容</span>
    <span style='color:red'>{{ excelremark }}</span>  
</pre>
      </p>
      <Input v-model="textdata" type="textarea" placeholder="尝试从网页、Excel 或其它软件复制一段表格数据，粘贴在这里" autoheight :rows="15" />
    </Modal>
    <Modal v-model="excelmodal" title="本地模式" width='700px' id='wbms'>
      <p>
      <pre>
  请将：<strong>【{{ tablehead }}】</strong>设置为Excel表头，或 <span class='downmb' @click='downtmp'>下载模板</span>
        已有模板内容：<Button type="primary" size='small' class='downcsv' icon="ios-cloud-upload-outline" @click='clickFile'>导入数据<input id="upload" ref='clickFile' type="file" @change="importfxx" style='display:none' /></Button>
        <span style='color:red'>{{ excelremark }}</span>  
</pre>
      </p>

    </Modal>

  </div>
</template>
<script src="http://display.incich.com:9208/Upload/html/upload/dist/js/xlsx.full.min.js"></script>
<script>
  import utils from '../utils/getSchoolData.js'
  export default {
    name: 'importxls',
    mounted() {
      var that = this
    
      this.curUser = JSON.parse(localStorage.getItem('inchUserinfo'))
      this.curSchoolid = localStorage.getItem('curSchoolid')
      // this.data ='荣誉名称 荣誉获得时间 年级 班级 姓名 名次 学分<br/>歌唱小能手 2023-01-02 一年级 （1）班 小米 1 20'
      var tHeader = that.thead =  that.exportExcelData.thead 
      var filterVal = that.filterVal =  that.exportExcelData.filterVal
      var mockData = that.mockData = that.exportExcelData.mockData  
      that.excelremark = that.exportExcelData.excelremark 
      that.curUrl = that.exportExcelData.curUrl
      that.downloadUrl = that.exportExcelData.downUrl
      var arrs = []
      var ojb = {}
      var columns = []
      var textdata = mockData.join(' ')
      filterVal.map(function(val,index){
       
        var ojbData = {title:tHeader[index],key:filterVal[index]}
          ojbData['render'] = function(h,params){
               return h('Input',{
                               props: {
                                   value:params.row[val],
                                   size:'small',
                               },
                              on: {
                                   input: (inputtext) => {
                                     console.log(inputtext,'val',val,params.row._index)
                                     that.data[params.row._index][val] = inputtext
                                   },
                                   blur:(val)=>{
                                     console.log(val,h,)
                                   }
                               },
                        })
             }
        columns.push(ojbData)
        ojb[filterVal[index]] = mockData[index]
      })
      arrs.push(ojb)
      console.log(arrs,'arrs')
      this.temp = arrs
      this.textdata = textdata
      this.columns = columns
      this.tablehead = that.thead.join(' ')
     
    },
    props: {
      exportExcelData: {
        type:Object,
        default: () => {},
      },
      showxls:{
        default:false,
      },
      downUrl:{
        default:'',
      }
    },
    watch:{
      showxls(newval,oldval){
        console.log(newval)
        this.modal = newval
       
      },
      downUrl(newval,oldval){
        console.log(newval)
        this.downloadUrl = newval
       
      },
      textdata(newval,oldval){
        console.log(newval,oldval)
        this.getTableData(forma(newval))
        function forma(strValue){
          return strValue.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;');
        }
      }
    },
    data() {
      return {
        thead:[],
        filterVal:[],
        mockData:[],
        excelremark:'',
        curSchoolid:0,
        excelmodal:false,
        tablehead:[],
        temp:[],
        textmodal:false,
        modal:false,
        schoolData: [],
        textdata:'',
        columns:[],
        data:[],
        textdata:'',
        downloadUrl:'',
        // thtml:'',
        // columns8:[],
        // data6:[],
        //  tableData: [
        //         {'index':'999',"nickName": "的旧时光", "name": "98491231841251"},
        //         {'index':'1',"nickName": "高贵", "name": "张"},
        //         {'index':'2',"nickName": "海aaa灰尘", "name": "小兰"}
        //       ]
      }
    },
    methods: {

      saveData(){
        var that = this 
        var arr = []
        console.log(this.curUrl,that.data)
        var param = {}
        if(this.curUrl=='extracurricular/saveList'){ //学生荣誉导入
            that.data.map(function(val,index){
                val['schoolid'] = that.curSchoolid 
                val['gradeid']  = that.getGradeId(val['gradename'])
                val['classid']  = that.getClassId(val['gradename'],val['classname'])
                val['adduser']  = that.curUser.id
                val['addname']  = that.curUser.name
            })
            param['list'] = JSON.stringify(that.data)
        }else if(this.curUrl=='student/importStu'){
            param['classid']  = that.getClassId(that.data[0]['gradename'],that.data[0]['classname'])
            param['adduser']  = that.curUser.guid
            param['stulist'] = JSON.stringify(that.data)
        }else if(this.curUrl=='canteenAmountRecord/saveBatch'){
            param['name'] = []
            param['phone'] = [] 
            param['amount'] = []
            param['remark'] = []
           that.data.map(function(val,index){
             param['name'].push(val['name'])
             param['phone'].push(val['phone'])
             param['amount'].push(val['amount'])
             param['remark'].push(val['remark'])
           })
           param['name'] = param['name'].join(',')
           param['phone'] = param['phone'].join(',')
           param['amount'] = param['amount'].join(',')
           param['remark'] = param['remark'].join(',')
        }
        if(that.data.length ==0){
          that.$Message.error('未获取到数据')
          return false; 
        }
        console.log(param)
      
        this.$Modal.confirm({
              title: '提示',
              content: '<p>是否确认提交数据？</p>',
              onOk: () => {
                console.log(that.data)
                that.axios.post(that.curUrl,param).then(res=>{
                  that.$Message.info(res.msg)
                  that.modal = false
                  that.data = []
                  that.textdata = ''
                  that.$emit('actionData','success')
                })
              },
              onCancel: () => {

              }
            });
           
      },
      cancelModal(){
        console.log(this.modal)

        this.modal = false
        this.$emit('actionData','success')
      },
      clickFile() {
        this.$refs['clickFile'].click()
      },
      getTableData(data){
        console.log(data,'data')
        var that = this 
        if(data.indexOf('<br/>')<0 && data.indexOf('&nbsp;')<-1){
          that.$Message.error('文本格式不正确')
          return false;
        }
      
       
       
       
        var contentarr = data.split('<br/>')
        var newcontentarr = []
        contentarr.map(function(val,index){
          if(val!=''){
            var c = val.split('&nbsp;')
            var obj = {}
            c.map(function(v,i){
              if(that.filterVal[i]){
                obj[that.filterVal[i]] = v
              }else{
                that.$Message.info('内容超出表头列')
              }

            })
           
            newcontentarr.push(obj)
          }
          
        })
        // that.columns = newheadarr 
        that.data = newcontentarr
        console.log(newcontentarr)
      
      },
      importfxx(event) {
        if (!event.currentTarget.files.length) {
          return
        }
        const that = this
        // 拿取文件对象
        var f = event.currentTarget.files[0]
        // 用FileReader来读取
        var reader = new FileReader()
        // 重写FileReader上的readAsBinaryString方法
        FileReader.prototype.readAsBinaryString = function(f) {
          var binary = ''
          var wb // 读取完成的数据
          var outdata // 你需要的数据
          var reader = new FileReader()
          reader.onload = function(e) {
            // 读取成Uint8Array，再转换为Unicode编码（Unicode占两个字节）
            var bytes = new Uint8Array(reader.result)
            var length = bytes.byteLength
            for (var i = 0; i < length; i++) {
              binary += String.fromCharCode(bytes[i])
            }
            // 接下来就是xlsx了，具体可看api
            wb = XLSX.read(binary, {
              type: 'binary'
            })
           
            outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
         
            that.getxls(outdata)
            document.getElementById('upload').value = ''
            // 自定义方法向父组件传递数据

            // var persons = that.addTeacher(outdata)
            // var week = []
            // for (var i = 0; i < persons.length; i++) {
            //   if (persons[i]["上课时间"]) {
            //     week.push(persons[i])
            //   }
            // }
            // console.log(week, 111)
            // that.formateData(week)
            // that.csv2table(outdata)
            // that.$emit('getResult', outdata)
          }
          reader.readAsArrayBuffer(f)
        }
        reader.readAsBinaryString(f)
        
      },
      getxls(outdata){
        this.excelmodal = false
        var that = this 
        var arr = []
        var textdata = []
        outdata.map(function(val,index){
          var obj = {}
          var txt = []
          for(var key in val){
            if(that.thead.indexOf(key)>-1){
              obj[that.filterVal[that.thead.indexOf(key)]] = val[key]
            }
            // txt.push(val[key])  //显示到输入框
          }
          arr.push(obj)
          
          // textdata.push(txt.join('&nbsp;'))
        })
        that.data = arr
        // that.textdata = textdata,join('<br/>')
      },
      downtmp(){
        // var obj = [{'title':'歌唱小能手','begintime':'2023-01-02','gradename':'一年级','classname':'（1）班','name':'小米','rank':'1','stucode':'20'}]
        console.log(this.temp,this.downloadUrl)
        var that = this 
        if(this.downloadUrl){
          that.axios.get(that.downloadUrl,{}).then(res=>{
             var arr = []
             res.data.map(function(val,index){
                var obj = {'name':val['name'],phone:val['phone'],amount:'',remark:''}
               
                arr.push(obj)
             })
             console.log(arr,'arr')
             that.export2Excel(arr,that.exportExcelData.excelTitle, that.thead, that.filterVal)
          })
        }else{
          this.export2Excel(this.temp,this.exportExcelData.excelTitle, this.thead, this.filterVal)
        }
       
      },
      generRateData(headArr,keyArr,tempName){
       
      
      },
      export2Excel(itemData,excelTitle,tHeader,filterVal) {   //itemData 是数据源    excelTitle 是文件名字   tHeader 是excel第一行标题   filterVal  是对应的字段
        var that = this  
        // require.ensure([], () => {
        //     const { export_json_to_excel } = require('../excel/Export2Excel');
        //     const list = itemData;  //把data里的tableData存到list
        //     const data = that.formatJson(filterVal, list);
        //     export_json_to_excel(tHeader, data, excelTitle);  //导出Excel 文件名
        //   })
        },
        formatJson(filterVal, jsonData) {
          return jsonData.map(v => filterVal.map(j => v[j]))
        },
        formatDate(numb, format) {
            const time = new Date((numb - 1) * 24 * 3600000 + 1)
            time.setYear(time.getFullYear() - 70)
            const year = time.getFullYear() + ''
            const month = time.getMonth() + 1 + ''
            const date = time.getDate() - 1 + ''
            if (format && format.length === 1) {
                return year + format + month + format + date
            }
            return year + (month < 10 ? '0' + month : month) + (date < 10 ? '0' + date : date)
        },
        getGradeId(name){
        var _id = ''
        this.schoolData.map(function(val,index){
         
          if(name == val['name']){
            _id = val['id']
          }
        })
        return _id
      },
      getClassId(gradename,classname){
        var that = this 
        var _id = ''
        this.schoolData.map(function(val,index){
          if(gradename == val['name']){
             var classes = val['children']
             classes.map(function(vals,indexs){
               if(vals['name']==classname){
                _id = vals['id']
               }
             })
          }
        })
        return _id
      },
    },

  }
</script>

<style scoped>
.leaveStu {
  padding-top: 20px;
  padding-right: 20px;
  padding-bottom: 50px;
  overflow-x: hidden;
}

.downcsv {
  font-size: 14px !important
}

ul {
  width: 100%;
  /* display:flex;
    justify-content:space-between */
}

li {
  width: 100%;
  list-style: none;
}

.downmb {
  text-decoration: underline;
  color: #2d8cf0;
  cursor: pointer;
}
</style>
